import { createSlice } from '@reduxjs/toolkit';
import type { UCBalance } from '../../types/api/uc';

interface UCBalanceState {
  balance: UCBalance | null;
}

const initialState: UCBalanceState = {
  balance: null,
};

const ucBalanceSlice = createSlice({
  name: 'ucBalance',
  initialState,
  reducers: {
    setUCBalance: (state, action: { payload: UCBalance }) => {
      state.balance = action.payload;
    },
    clearUCBalance: (state) => {
      state.balance = null;
    },
  },
});

export const { setUCBalance, clearUCBalance } = ucBalanceSlice.actions;
export default ucBalanceSlice.reducer;
